module.exports = __webpack_public_path__ + "img/dia_do_trabalho.da01f638.svg";